import { render, staticRenderFns } from "./ThePartner.vue?vue&type=template&id=6faa1639&"
import script from "./ThePartner.vue?vue&type=script&lang=js&"
export * from "./ThePartner.vue?vue&type=script&lang=js&"
import style0 from "./ThePartner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports